import React, { ReactElement, useEffect, useState } from 'react'
import { ContainerTabela } from '@pages/style'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  Button,
  Card,
  Col,
  Input,
  Popconfirm,
  Row,
  Space,
  Table,
  Typography,
} from 'antd'
import { useFetch, useRouter } from '@customHooks'
import { ICargo } from '@app'
import api from '@services/api'
import { getCargoById, useCargos } from '@services/mapping/manutencao'
import { useQueryClient } from 'react-query'
import { SECONDS } from '@services/utils'

const { Column } = Table

export default function Cargos(): ReactElement {
  const { navigate } = useRouter()
  const queryClient = useQueryClient()
  const { cargos, isLoading } = useCargos()
  const [source, setSource] = useState<ICargo[]>([] as ICargo[])

  const prefetch = async (id: number) => {
    queryClient.prefetchQuery(['cargo', id], () => getCargoById(id), {
      staleTime: 10 * SECONDS,
    })
  }

  const onDelete = async (id: number) => {
    await api
      .delete(`/cargo/${id}`)
      .finally(() => queryClient.invalidateQueries('cargos'))
  }

  useEffect(() => {
    if (cargos) {
      setSource(cargos)
    }
  }, [cargos])

  return (
    <ContainerTabela>
      <Card style={{ margin: '1rem 0' }}>
        <Row align='middle' justify='space-between'>
          <Col>
            <Typography.Title level={4}>Cargos</Typography.Title>
          </Col>
          <Col span={16}>
            <Input
              key='search'
              allowClear
              placeholder='Pesquise aqui...'
              onChange={({ target: { value } }) => {
                if (cargos) {
                  const filtered = cargos.filter(
                    ({ DESCCARGO }) =>
                      DESCCARGO.toLowerCase().indexOf(value.toLowerCase()) > -1
                  )
                  setSource(filtered)
                }
              }}
            />
          </Col>
          <Col>
            <Button
              icon={<PlusOutlined />}
              size='large'
              type='primary'
              onClick={() => navigate('novo')}
            >
              Novo
            </Button>
          </Col>
        </Row>
      </Card>
      <Table
        loading={isLoading}
        dataSource={source}
        rowKey={(record) => record.ID_CARGO}
      >
        <Column<ICargo>
          title='Cód.'
          dataIndex='ID_CARGO'
          width='10%'
          sorter={(a, b) => a.ID_CARGO - b.ID_CARGO}
        />
        <Column<ICargo>
          title='Atividade'
          dataIndex='DESCCARGO'
          sorter={(a, b) => a.DESCCARGO.localeCompare(b.DESCCARGO)}
        />
        <Column<ICargo>
          width='10%'
          render={(_, record) => (
            <Space>
              <Button
                onClick={() => navigate(`${record.ID_CARGO}`)}
                onMouseEnter={() => prefetch(record.ID_CARGO)}
                type='link'
                icon={<EditOutlined />}
              />
              <Popconfirm
                title='Deseja realmente excluir este registro?'
                onConfirm={() => onDelete(record.ID_CARGO)}
              >
                <Button type='text' icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          )}
        />
      </Table>
    </ContainerTabela>
  )
}
